// Usuario logueado
export const datosUsuarioLogueado = state => state.mis_datos.currentUser;
